import React, { useState } from 'react'
import Sidebar from '../components/CommonSections/SideBar';
import Navbar from '../components/CommonSections/Navbar';
import Footer from '../components/CommonSections/Footer';

const ArticlesPage = () => {

    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }
    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />
            <Footer />
        </>
    )
}

export default ArticlesPage